import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';

import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';
import { useMentionPersonas } from '@web/common/hooks/useMentionPersonas/useMentionPersonas';

export const useCommentEditPersonas = (pageId: number | null) => {
  const { users } = usePersonaCollection();
  const { getPageMemberIds } = useNewsfeedBridge();

  const memberIds = useMemo(() => {
    if (pageId === null) {
      return [];
    }

    const isNewsfeedMainPage = pageId === 0;

    return isNewsfeedMainPage ? users.map((u) => u.id) : getPageMemberIds(pageId);
  }, [pageId, users, getPageMemberIds]);
  const mentionPersonas = useMentionPersonas(memberIds);

  return { mentionPersonas };
};
